import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Hotspot } from './hotspot.model';
import { URL_BASE } from '../../core/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpUtils } from '../../shared/http-utils';
import { CustomEncoder } from '../../shared/custom-encoder';
import { SortDirection } from '../../shared/sort-direction';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { HotspotSearchCriteria } from './hotspot-search-criteria.model';
import { map } from 'rxjs/operators';

@Injectable()
export class HotspotService {

  private HOTSPOTS_URI = 'hotspots';

  constructor(private http: HttpClient) {
  }

  public getById(id: string): Observable<Hotspot> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.HOTSPOTS_URI}/${id}`;

    return this.http.get(url, { headers })
      .pipe(
        map(h => Hotspot.fromDto(h))
      );
  }

  public create(hotspot: Hotspot): Observable<Hotspot> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.HOTSPOTS_URI}`;

    return this.http.post(url, hotspot, { headers })
      .pipe(
        map(h => Hotspot.fromDto(h))
      );
  }

  public update(hotspot: Hotspot): Observable<Hotspot> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.HOTSPOTS_URI}/${hotspot.id}`;

    return this.http.put(url, hotspot, { headers })
      .pipe(
        map(h => Hotspot.fromDto(h))
      );
  }

  public remove(id: string): Observable<any> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.HOTSPOTS_URI}/${id}`;

    return this.http.delete(url, { headers });
  }

  public search(
    page: number, size: number, sortColumn: string, direction: SortDirection, criteria: HotspotSearchCriteria
  ): Observable<SearchObjectResult<Hotspot>> {

    const params = {
      page: String(page),
      size: String(size),
      sort: sortColumn,
      direction,
      ...criteria
    };

    for (const key of Object.keys(params)) {
      if (!params[key]) {
        delete params[key];
      }
    }

    const headers    = HttpUtils.createHeaders();
    const httpParams = new HttpParams({
      encoder: new CustomEncoder(),
      fromObject: params
    });

    const url = `${URL_BASE}/api/${this.HOTSPOTS_URI}/search`;
    return this.http.get(url, { headers, params: httpParams })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, Hotspot.fromDto))
      );
  }

}
